<template>
  <div>
    <!-- Label -->
    <label :class="labelComputedClasses" :for="id">
      <span>{{ label }}</span>
      <ips-tooltip v-if="tooltip" :tooltip="tooltip">
        <template slot="tip">
          <ips-icon icon="ico-help"></ips-icon>
        </template>
      </ips-tooltip>
    </label>
    <div :class="formComputedClasses">
      <select
        :id="id"
        v-model="selected"
        class="form-control"
        :class="inputComputedClasses"
        :disabled="disabled"
        :required="required"
        :tabindex="tabindex"
        @change="onSelect"
      >
        <slot name="options"></slot>
      </select>
      <small v-if="error" class="ips-validation form-text text-danger">
        <ips-icon icon="ico-danger" size="sm"></ips-icon>
        <!-- @slot Use this slot to populate a validation/error message -->
        <slot name="errorText"></slot>
      </small>
    </div>
  </div>
</template>

<script>
import IpsIcon from '@ipscape/ips-icon';
import IpsTooltip from '@ipscape/ips-tooltip';
import { formFieldsMixin } from './../../../mixins/index.js';

export default {
  name: 'IpsSelect',
  components: {
    IpsIcon,
    IpsTooltip,
  },
  mixins: [formFieldsMixin],
  data() {
    return {
      selected: this.value,
    };
  },
  methods: {
    onSelect(event) {
      this.$emit('select', this.selected ? this.selected : event.target.value);
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'IpsSelect';
</style>
